import { api } from "@/axios";
import { skip } from "@/utils/helpers";
import Vue from "vue";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";

const state = {
  employees: [],
  pagination: {},
  user: {}
};

const mutations = {
  set_employee(state, val) {
    state.employees = val;
  },
  set_pagination(state, val) {
    state.pagination = val;
  },
  set_user_details(state, val) {
    state.user = val;
  }
};

const actions = {
  async addEmployee({ commit, dispatch }, payload) {
    if (permissionsMiddleWare("Create Employee")) {
      commit("set_loading", true, { root: true });
      return await new Promise((resolve, reject) => {
        api
          .post("/employ", payload)
          .then(res => {
            dispatch("getEmployees");
            commit("set_loading", false, { root: true });
            resolve(res);
          })
          .catch(error => {
            reject(error);
            commit("set_loading", false, { root: true });
          });
      });
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : Create Employee",
        { duration: 3000 }
      );
    }
  },
  async getEmployees({ commit, rootState }, val) {
    const { isOther } = rootState.auth.user;
    const query = {
      take: 30,
      skip: skip(val),
      page_no: val,
      isOther: isOther
    };
    try {
      if (permissionsMiddleWare("List Employees")) {
        commit("set_loading", true, { root: true });
        const employees = await api.get("/employ", {
          params: { ...query }
        });
        commit("set_employee", employees.data.result.employ);
        commit("set_pagination", employees.data.result.pagination);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : List Employees",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async filterEmployees({ commit }, val) {
    try {
      commit("set_loading", true, { root: true });
      const employees = await api.get(`/employ?query=${val}`);
      commit("set_employee", employees.data.result.employ);
      commit("set_pagination", employees.data.result.pagination);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async userDetails({ commit, rootState }, id) {
    if (permissionsMiddleWare("View Employee")) {
      commit("set_loading", true, { root: true });
      const employId = rootState.auth.user && rootState.auth.user.employId;
      const details = await api.get(`/employ/${id ? id : employId}`);
      const user = details.data.result;
      commit("set_user_details", user);
      commit("set_loading", false, { root: true });
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : View Employee",
        { duration: 3000 }
      );
    }
  },
  async handleUpdateUsers({ commit }, { id, user }) {
    try {
      if (permissionsMiddleWare("Update Employee")) {
        commit("set_loading", true, { root: true });
        await api.put(`/employ/${id}`, user);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Update Employee",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async deleteUser({ commit, dispatch }, id) {
    try {
      if (permissionsMiddleWare("Delete Employee")) {
        commit("set_loading", true, { root: true });
        await api.delete(`/employ/${id}`);
        await dispatch("getEmployees");
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Delete Employee",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async setStatus({ dispatch, commit }, { id, payload }) {
    if (permissionsMiddleWare("Update Employee Status")) {
      commit("set_loading", true, { root: true });
      await api.put(`/employ/status/${id}`, payload);
      await dispatch("getEmployees");
      commit("set_loading", false, { root: true });
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : Update Employee Status",
        { duration: 3000 }
      );
    }
  }
};

const getters = {
  listEmployees: state => state.employees,
  getPagination: state => state.pagination || {},
  userInfo: state => state.user && state.user.employ,
  getUser: state => {
    const { employ, fetchedUser, fetchedUserRole } = state && state.user;
    return {
      full_name: employ && employ.full_name,
      isOther: fetchedUser && fetchedUser.isOther,
      dob: employ && employ.dob,
      email: employ && employ.email,
      gender: employ && employ.gender,
      cnic: employ && employ.cnic,
      mobile_no: employ && employ.mobile_no,
      city: employ && employ.city,
      address: employ && employ.address,
      description: employ && employ.description,
      role_name:
        fetchedUserRole && fetchedUserRole.role && fetchedUserRole.role.name,
      user_name: fetchedUser && fetchedUser.user_name,
      joinedDate: employ && employ.joinedDate,
      userSession: fetchedUser && fetchedUser.userSessions,
      is2fa: fetchedUser && fetchedUser.twoFactorAuthEnabled,
      userId: fetchedUser && fetchedUser.id
    };
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
